import Phase from '../phase';

/**
 * Create the action
 */

const { thunk, request, success, error } = Phase.index((fetch) => {
    return fetch.get('/phases');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
